// removed by extract-text-webpack-plugin
module.exports = {"card-form":"billing-details__card-form___1QRI9","form-title":"billing-details__form-title___1Ihhn","field-cell":"billing-details__field-cell___1toGQ","fields":"billing-details__fields___2pPKs","small-field":"billing-details__small-field___3D1AG","expiration":"billing-details__expiration___12DBQ","expiration-right":"billing-details__expiration-right___2UhqG","cvv":"billing-details__cvv___1pZ0A","button":"billing-details__button___3oRtL","construction":"billing-details__construction___3g2t-"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/billing-details.scss
// module id = 1355
// module chunks = 0